import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import BaseballMatchRelativeRecordStore from './store';
import PlayerDefaultImg from 'images/sports/common/player-default.png';
// import SingleBarChart from 'components/charts/bar';
// import clsx from 'clsx';
import BaseballMatchRecordTable from './table';
import { observer } from 'mobx-react';
import BaseballMatchRecordBattingTable from './battingTable';
import BaseballMatchRankTable from './rankTable';
// import SportsTeamLogo from 'components/teamLogo';
import {
  Record,
  Container,
  Header,
  HeaderNonBorder,
  StartFitcherContents,
  StartFitcherPlayer,
  StartFitcherImage,
  StartFitcherInfo,
  VsSquare,
  ChartContents,
  ChartArea,
  ChartDivider,
  ChartHeader,
  Tab,
  Button
} from './styled';
import SingleBarChart from '../../../../../components/charts/bar';
import clsx from 'clsx';
import SportsTeamLogo from '../../../../../components/teamLogo';
import Seo from '../../../../../components/seo';

const BaseballMatchRelativeRecord = observer(() => {
  let { id } = useParams();
  const { getAll, data } = BaseballMatchRelativeRecordStore();

  useEffect(() => {
    getAll(id);
  }, []);

  if (data.loading) {
    return null;
  } else {
    return (
      <Record>
        <Seo title={'스포츠 야구 상세 전력'} />
        {/* 선발투수 정보 시작 */}
        <Container>
          <HeaderNonBorder>
            <h2>선발투수</h2>
          </HeaderNonBorder>
          <StartFitcherContents>
            {/* 홈 선수 */}
            <StartFitcherPlayer>
              <StartFitcherImage>
                <img src={PlayerDefaultImg} alt="선발투수" />
              </StartFitcherImage>
              <StartFitcherInfo>
                <span>{data.playerStat.home.player.name}</span>
                {data.playerStat.home.player.visible ? (
                  <span>{data.playerStat.home.player.wlq}</span>
                ) : (
                  <span>{data.playerStat.home.player.noDataWlq}</span>
                )}
                {data.playerStat.home.player.visible ? (
                  <span>{data.playerStat.home.player.vs}</span>
                ) : (
                  <span>{data.playerStat.home.player.noDataVs}</span>
                )}
              </StartFitcherInfo>
            </StartFitcherPlayer>

            <VsSquare>
              <span>VS</span>
            </VsSquare>

            {/* 어웨이 선수 */}
            <StartFitcherPlayer>
              <StartFitcherImage>
                <img src={PlayerDefaultImg} alt="선발투수" />
              </StartFitcherImage>
              <StartFitcherInfo>
                <span>{data.playerStat.away.player.name}</span>
                {data.playerStat.away.player.visible ? (
                  <span>{data.playerStat.away.player.wlq}</span>
                ) : (
                  <span>{data.playerStat.away.player.noDataWlq}</span>
                )}
                {data.playerStat.away.player.visible ? (
                  <span>{data.playerStat.away.player.vs}</span>
                ) : (
                  <span>{data.playerStat.away.player.noDataVs}</span>
                )}
              </StartFitcherInfo>
            </StartFitcherPlayer>
          </StartFitcherContents>

          {/* 차트 */}
          <ChartContents>
            <li>
              <ChartHeader>
                <span>{data.starterFitcherChart.era.home.v}</span>
                <span>평균 자책점</span>
                <span>{data.starterFitcherChart.era.away.v}</span>
              </ChartHeader>
              <ChartArea>
                <SingleBarChart
                  value={data.starterFitcherChart.era.home.p}
                  active={
                    data.starterFitcherChart.era.visible &&
                    data.starterFitcherChart.era.home.active
                  }
                  location="left"
                />
                <ChartDivider />
                <SingleBarChart
                  value={data.starterFitcherChart.era.away.p}
                  active={
                    data.starterFitcherChart.era.visible &&
                    data.starterFitcherChart.era.away.active
                  }
                  location="right"
                />
              </ChartArea>
            </li>
            <li>
              <ChartHeader>
                <span>{data.starterFitcherChart.whip.home.v}</span>
                <span>WHIP</span>
                <span>{data.starterFitcherChart.whip.away.v}</span>
              </ChartHeader>
              <ChartArea>
                <SingleBarChart
                  value={data.starterFitcherChart.whip.home.p}
                  active={
                    data.starterFitcherChart.whip.visible &&
                    data.starterFitcherChart.whip.home.active
                  }
                  location="left"
                />
                <ChartDivider />
                <SingleBarChart
                  value={data.starterFitcherChart.whip.away.p}
                  active={
                    data.starterFitcherChart.whip.visible &&
                    data.starterFitcherChart.whip.away.active
                  }
                  location="right"
                />
              </ChartArea>
            </li>
            <li>
              <ChartHeader>
                <span>{data.starterFitcherChart.hitAvg.home.v}</span>
                <span>경기당 피안타</span>
                <span>{data.starterFitcherChart.hitAvg.away.v}</span>
              </ChartHeader>
              <ChartArea>
                <SingleBarChart
                  value={data.starterFitcherChart.hitAvg.home.p}
                  active={
                    data.starterFitcherChart.hitAvg.visible &&
                    data.starterFitcherChart.hitAvg.home.active
                  }
                  location="left"
                />
                <ChartDivider />
                <SingleBarChart
                  value={data.starterFitcherChart.hitAvg.away.p}
                  active={
                    data.starterFitcherChart.hitAvg.visible &&
                    data.starterFitcherChart.hitAvg.away.active
                  }
                  location="right"
                />
              </ChartArea>
            </li>
            <li>
              <ChartHeader>
                <span>{data.starterFitcherChart.so9.home.v}</span>
                <span>9이닝당 삼진</span>
                <span>{data.starterFitcherChart.so9.away.v}</span>
              </ChartHeader>
              <ChartArea>
                <SingleBarChart
                  value={data.starterFitcherChart.so9.home.p}
                  active={
                    data.starterFitcherChart.so9.visible &&
                    data.starterFitcherChart.so9.home.active
                  }
                  location="left"
                />
                <ChartDivider />
                <SingleBarChart
                  value={data.starterFitcherChart.so9.away.p}
                  active={
                    data.starterFitcherChart.so9.visible &&
                    data.starterFitcherChart.so9.away.active
                  }
                  location="right"
                />
              </ChartArea>
            </li>
            <li>
              <ChartHeader>
                <span>{data.starterFitcherChart.bb.home.v}</span>
                <span>경기당 볼넷</span>
                <span>{data.starterFitcherChart.bb.away.v}</span>
              </ChartHeader>
              <ChartArea>
                <SingleBarChart
                  value={data.starterFitcherChart.bb.home.p}
                  active={
                    data.starterFitcherChart.bb.visible &&
                    data.starterFitcherChart.bb.home.active
                  }
                  location="left"
                />
                <ChartDivider />
                <SingleBarChart
                  value={data.starterFitcherChart.bb.away.p}
                  active={
                    data.starterFitcherChart.bb.visible &&
                    data.starterFitcherChart.bb.away.active
                  }
                  location="right"
                />
              </ChartArea>
            </li>
          </ChartContents>
        </Container>
        {/* 선발투수 정보 끝 */}

        {/* 상대전적 시작 */}
        {data.record.vsRecord.length > 0 && (
          <Container>
            <Header>
              <h2>상대전적</h2>
            </Header>

            <BaseballMatchRecordTable data={data.record.vsRecord} />
            {/* <div className={style.info}>
    <div className={style.infoHeader}>
      <span>
        ※ 시즌 상대전적은 최근 10경기까지만 노출되며 배당률 및
        기준점은 베트맨을 기준으로 합니다.
      </span>
    </div>
    <ul className={style.infoSummary}>
      <li>
        <div />
        상대전적 기록으로는
        <span className={style.spanRed} style={{ marginLeft: 2 }}>
          {data.vsRecordSummary.vs}
        </span>
        를 기록하고 있습니다.
      </li>
      <li>
        <div />
        {data.vsRecordSummary.handicap.text}
        <span className={style.spanRed}>
          {data.vsRecordSummary.handicap.red}
        </span>
        입니다.
      </li>
      <li>
        <div />
        {data.vsRecordSummary.unover.text}
        <span className={style.spanRed} style={{ marginLeft: 2 }}>
          {data.vsRecordSummary.unover.red}
        </span>
        를 기록했습니다.
      </li>
      {data.vsRecordSummary.home.visible && (
        <li>
          <div />
          {data.vsRecordSummary.home.text}
          <span className={style.spanBold}>
            {data.vsRecordSummary.home.bold}
          </span>
          를 기록 했습니다.
        </li>
      )}
      {data.vsRecordSummary.away.visible && (
        <li>
          <div />
          {data.vsRecordSummary.away.text}
          <span className={style.spanBold}>
            {data.vsRecordSummary.away.bold}
          </span>
          를 기록 했습니다.
        </li>
      )}

      {data.vsRecordSummary.win.visible && (
        <li>
          <div />
          {data.vsRecordSummary.win.text}
        </li>
      )}
    </ul>
  </div> */}
          </Container>
        )}
        {/* 상대전적 끝 */}
        {/* 최근 5경기 */}
        <Container>
          <Header>
            <h2>최근 5경기</h2>
          </Header>

          <Tab>
            <Button
              className={clsx(
                data.record.selectedRecentRecordTab === 'home' ? 'active' : ''
              )}
              onClick={() => data.record.onClickTab('home')}
            >
              {data.record.tabs.home}
            </Button>
            <Button
              className={clsx(
                data.record.selectedRecentRecordTab === 'away' ? 'active' : ''
              )}
              onClick={() => data.record.onClickTab('away')}
            >
              {data.record.tabs.away}
            </Button>
          </Tab>

          <BaseballMatchRecordTable data={data.record.recentRecord} />
          {/* <div className={style.info}>
  <div className={style.infoHeader}>
    <span>※ 배당률 및 기준점은 베트맨을 기준으로 합니다.</span>
  </div>
  <ul className={style.infoSummary}>
    <li>
      <div />
      {data.recentRecordSummary.total.text}
      <span className={style.spanRed}>
        {data.recentRecordSummary.total.red}
      </span>
      를 기록하고 있습니다.
    </li>
    <li>
      <div />
      {data.recentRecordSummary.type.text}
      <span className={style.spanRed}>
        {data.recentRecordSummary.type.red}
      </span>
      를 기록했습니다.
    </li>
    <li>
      <div />
      {data.recentRecordSummary.win.text}
      <span className={style.spanBold}>
        {data.recentRecordSummary.win.bold}
      </span>
    </li>
  </ul>
</div> */}
        </Container>
        {/* 최근 5경기 끝 */}
        {/* 전력 비교 */}
        <Container>
          <HeaderNonBorder>
            <h2>전력 비교</h2>
          </HeaderNonBorder>
          <StartFitcherContents>
            {/* 홈 선수 */}
            <StartFitcherPlayer>
              <StartFitcherImage>
                <SportsTeamLogo
                  imgSize={60}
                  imgUrl={data.teamStat.home.imgPath}
                  isLazy={false}
                  location="home"
                />
              </StartFitcherImage>
              <StartFitcherInfo>
                <span>{data.teamStat.home.name}</span>
                <span>{data.teamStat.home.stat.season}</span>
                <span>{`vs ${data.teamStat.away.name} ${data.teamStat.home.stat.vs}`}</span>
              </StartFitcherInfo>
            </StartFitcherPlayer>

            <VsSquare>
              <span>VS</span>
            </VsSquare>

            {/* 어웨이 선수 */}
            <StartFitcherPlayer>
              <StartFitcherImage>
                <SportsTeamLogo
                  imgSize={60}
                  imgUrl={data.teamStat.away.imgPath}
                  isLazy={false}
                  location="away"
                />
              </StartFitcherImage>
              <StartFitcherInfo>
                <span>{data.teamStat.away.name}</span>
                <span>{data.teamStat.away.stat.season}</span>
                <span>{`vs ${data.teamStat.home.name} ${data.teamStat.away.stat.vs}`}</span>
              </StartFitcherInfo>
            </StartFitcherPlayer>
          </StartFitcherContents>

          {/* 차트 */}
          <ChartContents>
            <li>
              <ChartHeader>
                <span>{data.comparisonChart.era.home.v}</span>
                <span>평균 자책점</span>
                <span>{data.comparisonChart.era.away.v}</span>
              </ChartHeader>
              <ChartArea>
                <SingleBarChart
                  value={data.comparisonChart.era.home.p}
                  active={
                    data.comparisonChart.era.visible &&
                    data.comparisonChart.era.home.active
                  }
                  location="left"
                />
                <ChartDivider />
                <SingleBarChart
                  value={data.comparisonChart.era.away.p}
                  active={
                    data.comparisonChart.era.visible &&
                    data.comparisonChart.era.away.active
                  }
                  location="right"
                />
              </ChartArea>
            </li>
            <li>
              <ChartHeader>
                <span>{data.comparisonChart.ops.home.v}</span>
                <span>OPS</span>
                <span>{data.comparisonChart.ops.away.v}</span>
              </ChartHeader>
              <ChartArea>
                <SingleBarChart
                  value={data.comparisonChart.ops.home.p}
                  active={
                    data.comparisonChart.ops.visible &&
                    data.comparisonChart.ops.home.active
                  }
                  location="left"
                />
                <ChartDivider />
                <SingleBarChart
                  value={data.comparisonChart.ops.away.p}
                  active={
                    data.comparisonChart.ops.visible &&
                    data.comparisonChart.ops.away.active
                  }
                  location="right"
                />
              </ChartArea>
            </li>
            <li>
              <ChartHeader>
                <span>{data.comparisonChart.avg.home.v}</span>
                <span>타율</span>
                <span>{data.comparisonChart.avg.away.v}</span>
              </ChartHeader>
              <ChartArea>
                <SingleBarChart
                  value={data.comparisonChart.avg.home.p}
                  active={
                    data.comparisonChart.avg.visible &&
                    data.comparisonChart.avg.home.active
                  }
                  location="left"
                />
                <ChartDivider />
                <SingleBarChart
                  value={data.comparisonChart.avg.away.p}
                  active={
                    data.comparisonChart.avg.visible &&
                    data.comparisonChart.avg.away.active
                  }
                  location="right"
                />
              </ChartArea>
            </li>
            <li>
              <ChartHeader>
                <span>{data.comparisonChart.hr.home.v}</span>
                <span>홈런</span>
                <span>{data.comparisonChart.hr.away.v}</span>
              </ChartHeader>
              <ChartArea>
                <SingleBarChart
                  value={data.comparisonChart.hr.home.p}
                  active={
                    data.comparisonChart.hr.visible &&
                    data.comparisonChart.hr.home.active
                  }
                  location="left"
                />
                <ChartDivider />
                <SingleBarChart
                  value={data.comparisonChart.hr.away.p}
                  active={
                    data.comparisonChart.hr.visible &&
                    data.comparisonChart.hr.away.active
                  }
                  location="right"
                />
              </ChartArea>
            </li>
            <li>
              <ChartHeader>
                <span>{data.comparisonChart.sb.home.v}</span>
                <span>도루</span>
                <span>{data.comparisonChart.sb.away.v}</span>
              </ChartHeader>
              <ChartArea>
                <SingleBarChart
                  value={data.comparisonChart.sb.home.p}
                  active={
                    data.comparisonChart.sb.visible &&
                    data.comparisonChart.sb.home.active
                  }
                  location="left"
                />
                <ChartDivider />
                <SingleBarChart
                  value={data.comparisonChart.sb.away.p}
                  active={
                    data.comparisonChart.sb.visible &&
                    data.comparisonChart.sb.away.active
                  }
                  location="right"
                />
              </ChartArea>
            </li>
            <li>
              <ChartHeader>
                <span>{data.comparisonChart.whip.home.v}</span>
                <span>WHIP</span>
                <span>{data.comparisonChart.whip.away.v}</span>
              </ChartHeader>
              <ChartArea>
                <SingleBarChart
                  value={data.comparisonChart.whip.home.p}
                  active={
                    data.comparisonChart.whip.visible &&
                    data.comparisonChart.whip.home.active
                  }
                  location="left"
                />
                <ChartDivider />
                <SingleBarChart
                  value={data.comparisonChart.whip.away.p}
                  active={
                    data.comparisonChart.whip.visible &&
                    data.comparisonChart.whip.away.active
                  }
                  location="right"
                />
              </ChartArea>
            </li>

            {data.comparisonChart.err.home.p === 0 &&
            data.comparisonChart.err.away.p === 0 ? null : (
              <li>
                <ChartHeader>
                  <span>{data.comparisonChart.err.home.v}</span>
                  <span>실책</span>
                  <span>{data.comparisonChart.err.away.v}</span>
                </ChartHeader>
                <ChartArea>
                  <SingleBarChart
                    value={data.comparisonChart.err.home.p}
                    active={
                      data.comparisonChart.err.visible &&
                      data.comparisonChart.err.home.active
                    }
                    location="left"
                  />
                  <ChartDivider />
                  <SingleBarChart
                    value={data.comparisonChart.err.away.p}
                    active={
                      data.comparisonChart.err.visible &&
                      data.comparisonChart.err.away.active
                    }
                    location="right"
                  />
                </ChartArea>
              </li>
            )}
          </ChartContents>
        </Container>
        {/* 전력 비교 끝 */}

        {/* 타자 기록 */}
        <Container>
          <HeaderNonBorder>
            <h2>타자 기록</h2>
          </HeaderNonBorder>
          <BaseballMatchRecordBattingTable
            data={data.playerStat}
            location="home"
          />
        </Container>

        {/* 스페셜 정보 */}
        <Container>
          <HeaderNonBorder>
            <h2>스페셜 정보</h2>
          </HeaderNonBorder>
          <StartFitcherContents>
            {/* 홈 선수 */}
            <StartFitcherPlayer>
              <StartFitcherImage>
                <SportsTeamLogo
                  imgSize={60}
                  imgUrl={data.teamStat.home.imgPath}
                  isLazy={false}
                  location="home"
                />
              </StartFitcherImage>
            </StartFitcherPlayer>

            <VsSquare>
              <span>VS</span>
            </VsSquare>

            {/* 어웨이 선수 */}
            <StartFitcherPlayer>
              <StartFitcherImage>
                <SportsTeamLogo
                  imgSize={60}
                  imgUrl={data.teamStat.away.imgPath}
                  isLazy={false}
                  location="away"
                />
              </StartFitcherImage>
            </StartFitcherPlayer>
          </StartFitcherContents>

          {/* 차트 */}
          <ChartContents>
            <li>
              <ChartHeader>
                <span>{data.specialChart.bob.home.v}</span>
                <span>첫볼넷</span>
                <span>{data.specialChart.bob.away.v}</span>
              </ChartHeader>
              <ChartArea>
                <SingleBarChart
                  value={data.specialChart.bob.home.p}
                  active={
                    data.specialChart.bob.visible &&
                    data.specialChart.bob.home.active
                  }
                  location="left"
                />
                <ChartDivider />
                <SingleBarChart
                  value={data.specialChart.bob.away.p}
                  active={
                    data.specialChart.bob.visible &&
                    data.specialChart.bob.away.active
                  }
                  location="right"
                />
              </ChartArea>
            </li>
            <li>
              <ChartHeader>
                <span>{data.specialChart.so.home.v}</span>
                <span>첫삼진</span>
                <span>{data.specialChart.so.away.v}</span>
              </ChartHeader>
              <ChartArea>
                <SingleBarChart
                  value={data.specialChart.so.home.p}
                  active={
                    data.specialChart.so.visible &&
                    data.specialChart.so.home.active
                  }
                  location="left"
                />
                <ChartDivider />
                <SingleBarChart
                  value={data.specialChart.so.away.p}
                  active={
                    data.specialChart.so.visible &&
                    data.specialChart.so.away.active
                  }
                  location="right"
                />
              </ChartArea>
            </li>
            <li>
              <ChartHeader>
                <span>{data.specialChart.hr.home.v}</span>
                <span>첫홈런</span>
                <span>{data.specialChart.hr.away.v}</span>
              </ChartHeader>
              <ChartArea>
                <SingleBarChart
                  value={data.specialChart.hr.home.p}
                  active={
                    data.specialChart.hr.visible &&
                    data.specialChart.hr.home.active
                  }
                  location="left"
                />
                <ChartDivider />
                <SingleBarChart
                  value={data.specialChart.hr.away.p}
                  active={
                    data.specialChart.hr.visible &&
                    data.specialChart.hr.away.active
                  }
                  location="right"
                />
              </ChartArea>
            </li>
          </ChartContents>
        </Container>

        {/* 스페셜 정보 끝 */}
        {/* 팀 순위 */}
        <Container>
          <BaseballMatchRankTable data={data.rank} team={data.teamStat} />
        </Container>
      </Record>
    );
  }
});

export default BaseballMatchRelativeRecord;
